module.exports = __webpack_public_path__ + "img/columns-02.161dac92.svg";